export default "__VITE_ASSET__CfcOltsP__"